import { render, staticRenderFns } from "./FlowSrvrsTable.vue?vue&type=template&id=f6f8a9e4&"
import script from "./FlowSrvrsTable.vue?vue&type=script&lang=js&"
export * from "./FlowSrvrsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports